import { KalenderDesktopContent } from '@/domain/termine/pages/kalender/KalenderDesktopContent';
import { KalenderMobileContent } from '@/domain/termine/pages/kalender/KalenderMobileContent';
import { cn } from '@/lib/utils';
import { Outlet } from 'react-router-dom';

export function KalenderUebersicht() {
  return (
    <div>
      <div
        className={cn(
          'hidden md:flex md:flex-col md:gap-8 md:p-4 md:w-screen',
          'lg:p-10 2xl:max-w-screen-2xl 2xl:mx-auto',
        )}>
        <KalenderDesktopContent />
      </div>
      <div className="block md:hidden">
        <KalenderMobileContent />
      </div>
      <Outlet />
    </div>
  );
}
